import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Source, Layer } from 'react-map-gl';
import { point, featureCollection } from '@turf/helpers';
import Shapes from '../../../utils/ShapeOfTypes';
import StopPopup from './StopPopup';
import { clusterLayer, unclusteredPointLayer } from './MapClusterConfig';
import mapboxConfig from './MapConfig';

const {
  clusterMaxZoom, clusterRadius,
} = mapboxConfig;

const getIconType = (stop) => {
  const routeType = stop.vehicle_type;
  if (routeType != null) {
    switch (routeType) {
      case 0: // Tram
      case 1: // Subway
      case 2: // Rail
        return 'train';
      case 4: // Ferry
        return 'ferry';
      default:
        return 'bus';
    }
  }
  return 'bus';
};

const convertStops = (stops) => {
  // Convert "stops" to GeoJson format
  const points = stops.map((stop) => {
    // eslint-disable-next-line camelcase, object-curly-newline
    const { stop_id, stop_lat, stop_lon } = stop;
    const stopIcon = getIconType(stop);
    // eslint-disable-next-line camelcase
    return point([stop_lon, stop_lat], { id: stop_id, icon: stopIcon });
  });

  return featureCollection(points);
};

const StopsLayer = ({
  enableAccessibilityOutlines,
  onPopupClose,
  selectedStop,
  selectStop,
  stops,
}) => {
  const [stopsFeatureCollection, setStopsFeatureCollection] = useState(() => convertStops(stops));

  useEffect(() => {
    setStopsFeatureCollection(convertStops(stops));
  }, [stops]);

  const _onSelect = () => {
    selectStop(selectedStop);
  };

  return (
    <>
      <Source
        id="stop_cluster"
        type="geojson"
        data={stopsFeatureCollection}
        cluster
        clusterMaxZoom={clusterMaxZoom}
        clusterRadius={clusterRadius}
      >
        <Layer {...clusterLayer} />
        <Layer {...unclusteredPointLayer} />
      </Source>
      <StopPopup
        enableAccessibilityOutlines={enableAccessibilityOutlines}
        offset={selectedStop ? 50 : 0}
        onPopupClose={onPopupClose}
        onSelect={_onSelect}
        selectedStop={selectedStop}
      />
    </>
  );
};

StopsLayer.propTypes = {
  enableAccessibilityOutlines: PropTypes.func.isRequired,
  onPopupClose: PropTypes.func.isRequired,
  selectedStop: PropTypes.object,
  selectStop: PropTypes.func.isRequired,
  stops: Shapes.Stops,
};
StopsLayer.defaultProps = {
  selectedStop: null,
  stops: [],
};

export default StopsLayer;
